// this should be the fn that returns fn
import initApiDietPaymentProcessor from "../../../../lib/common/js/apiDietPaymentProcessor"

const paymentBaseParams = {
  apiUrl: new URL("https://api.certifiedfasting.com"),
  paymodes: {
    paypal_recurring: 3,
    primer: 48,
  },
}

const apiDietPaymentProcessor = initApiDietPaymentProcessor(paymentBaseParams)

export default apiDietPaymentProcessor
